var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon",class:_vm.requirementClassObject},[_c('span',{staticClass:"icon-list__label",domProps:{"innerHTML":_vm._s(_vm.$present('requirementName', _vm.requirement))}}),_vm._v(" "),(_vm.data.complete)?_c('span',{staticClass:"icon",class:_vm.completeClassObject},[_vm._v("Complete")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }